import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '../../symbols';
import { format } from '@/@core/utils/string';
let GlobalViewApi = class GlobalViewApi {
    constructor(http, urls) {
        this.http = http;
        this.urls = urls;
        this.getGlobalViewCompanyList = (params) => {
            const { sEcho, iDisplayLength, iDisplayStart, ...otherParams } = params;
            return this.http.post({
                url: this.urls.getGlobalViewCompanyList,
                params: {
                    sEcho,
                    iDisplayLength,
                    iDisplayStart,
                },
                data: otherParams,
            });
        };
        this.getGlobalViewFields = (configKey) => {
            const url = format(this.urls.getGlobalViewFields, {
                configKey,
            });
            return this.http.get({
                url: url,
            });
        };
        this.putGlobalViewFields = (data) => {
            return this.http.post({
                url: this.urls.putGlobalViewFields,
                data,
            });
        };
        this.getGlobalViewUpdateTime = () => {
            return this.http.get({
                url: this.urls.getGlobalViewUpdateTime,
            });
        };
    }
};
GlobalViewApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.GlobalViewUrls)),
    __metadata("design:paramtypes", [Object, Object])
], GlobalViewApi);
export { GlobalViewApi };
